import React, { useState } from 'react';
import Chip from '@mui/material/Chip';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { withStyles } from '@mui/styles';
import PREDEFINED_TEMPLATES from './AIAssistantPredefinedTemplates';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const styles = (theme) => ({
  chipContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: '8px 0',
    gap: '8px',
  },
  chip: {
    margin: '4px',
    backgroundColor: theme.palette.action.hover,
    '&:hover': {
      backgroundColor: theme.palette.divider,
    },
  },
  activeChip: {
    margin: '4px',
    backgroundColor: '#e3f2fd',
    color: '#1976d2',
    borderColor: '#1976d2',
    '&:hover': {
      backgroundColor: '#bbdefb',
    },
  },
  sectionTitle: {
    paddingTop: '16px',
    paddingBottom: '8px',
    fontWeight: 'bold',
  },
  description: {
    paddingBottom: '8px',
    fontSize: '14px',
  },
});

const AIAssistantTemplateChips = ({ classes, onSelectTemplate, selectedTemplateId }) => {
  const [showAll, setShowAll] = useState(false);
  const initialDisplayCount = 3;

  const visibleTemplates = showAll
    ? PREDEFINED_TEMPLATES
    : PREDEFINED_TEMPLATES.slice(0, initialDisplayCount);
  const hasMoreTemplates = PREDEFINED_TEMPLATES.length > initialDisplayCount;

  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography className={classes.sectionTitle}>Assistant Templates</Typography>
      </Grid>
      <Grid item xs={12} className={classes.chipContainer}>
        {visibleTemplates.map(template => {
          const isSelected = template.id === selectedTemplateId;
          const tooltipTitle = isSelected
            ? `Click to clear the "${template.name}" template`
            : `Apply the "${template.name}" template`;

          return (
            <Tooltip title={tooltipTitle} key={template.id}>
              <Chip
                label={template.name}
                className={isSelected ? classes.activeChip : classes.chip}
                onClick={() => onSelectTemplate(template)}
                clickable
                variant={isSelected ? 'outlined' : 'default'}
                color={isSelected ? 'primary' : 'default'}
              />
            </Tooltip>
          );
        })}

        {hasMoreTemplates && (
          <Button
            size="small"
            onClick={() => setShowAll(!showAll)}
            style={{
              minWidth: 'auto',
              padding: '2px 8px',
              fontSize: '0.75rem',
              color: 'var(--mui-palette-text-secondary)',
              textTransform: 'none',
            }}
            endIcon={
              showAll ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />
            }
          >
            {showAll ? 'Show less' : 'Show more'}
          </Button>
        )}
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(AIAssistantTemplateChips);
